export default __webpack_public_path__ + "static/media/back.332470c1.svg";